import { NsSemanticColor } from "./ns-eds-types";

export const nsSemanticColors = [
  /* Content */
  "content",
  "contentEmphasis",
  "contentSubtle",
  "contentPlaceholder",
  "contentInverse",
  "contentInteractive",
  "contentInteractiveHover",
  "contentInteractivePressed",
  "contentInteractiveInverse",
  "contentSelected",
  "contentInfo",
  "contentSuccess",
  "contentWarning",
  "contentError",
  "contentDestructive",
  "contentDestructiveHover",
  "contentDestructivePressed",
  "contentOnAccentSubtle",
  "contentOnAccentYellow",
  "contentLogo",

  /* Background */
  "background",
  "backgroundElevated1",
  "backgroundElevated2",
  "backgroundElevated3",
  "backgroundSunken",
  "backgroundEmphasisPrimary",
  "backgroundEmphasisSecondary",
  "backgroundBrandPrimary",
  "backgroundBrandSecondary",
  "backgroundHover",
  "backgroundPressed",
  "backgroundSelected",
  "backgroundSelectedHover",
  "backgroundSelectedPressed",
  "backgroundSelectedOnBrandPrimary",
  "backgroundInteractive",
  "backgroundInteractiveHover",
  "backgroundInteractivePressed",
  "backgroundInput",
  "backgroundDiscovery",
  "backgroundAlpha",
  "backgroundAlphaSubtle",
  "backgroundInverse",
  "backgroundOverlay",
  "backgroundInfoSubtle",
  "backgroundInfo",
  "backgroundInfoHover",
  "backgroundInfoPressed",
  "backgroundSuccessSubtle",
  "backgroundSuccess",
  "backgroundSuccessHover",
  "backgroundSuccessPressed",
  "backgroundWarningSubtle",
  "backgroundWarning",
  "backgroundWarningHover",
  "backgroundWarningPressed",
  "backgroundErrorSubtle",
  "backgroundError",
  "backgroundErrorHover",
  "backgroundErrorPressed",
  "backgroundDestructive",
  "backgroundDestructiveHover",
  "backgroundDestructivePressed",
  "backgroundAccentGraySubtle",
  "backgroundAccentGray",
  "backgroundAccentBlueSubtle",
  "backgroundAccentBlue",
  "backgroundAccentGreenSubtle",
  "backgroundAccentGreen",
  "backgroundAccentOrangeSubtle",
  "backgroundAccentOrange",
  "backgroundAccentRedSubtle",
  "backgroundAccentRed",
  "backgroundAccentYellowSubtle",
  "backgroundAccentYellow",
  "backgroundAccentPurpleSubtle",
  "backgroundAccentPurple",
  "backgroundAccentPinkSubtle",
  "backgroundAccentPink",

  /* Border */
  "border",
  "borderSubtle",
  "borderEmphasis",
  "borderInverse",
  "borderInteractive",
  "borderInteractiveHover",
  "borderInteractivePressed",
  "borderInput",
  "borderInputHover",
  "borderInfo",
  "borderSuccess",
  "borderWarning",
  "borderError",
  "borderDestructive",
  "borderDestructiveHover",
  "borderDestructivePressed",
  "borderLogo",
  "borderSelected",
  "borderSelectedOnBrandPrimary",
  "borderFocus",
] as const;

export function isNsSemanticColor(color: string): color is NsSemanticColor {
  return nsSemanticColors.includes(color as NsSemanticColor);
}
